module.exports = [{
  "name": "Icon",
  "description": "",
  "props": {
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The name of the icon e.g. chevron, facebook etc."
    },
    "color": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The color of the icon",
      "defaultValue": {
        "value": "'currentColor'",
        "computed": false
      }
    },
    "size": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The size of the icon in ems",
      "defaultValue": {
        "value": "1",
        "computed": false
      }
    },
    "paths": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "The paths of a custom icon",
      "defaultValue": {
        "value": "[]",
        "computed": false
      }
    },
    "rotate": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Rotate the icon a certain number of degrees",
      "defaultValue": {
        "value": "0",
        "computed": false
      }
    },
    "spin": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Make the icon spin",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "viewBox": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Custom viewbox sizing",
      "defaultValue": {
        "value": "24",
        "computed": false
      }
    },
    "ariaHidden": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Override the default to hide icon from screen readers",
      "defaultValue": {
        "value": "true",
        "computed": false
      }
    },
    "styles": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Add custom styles to the icon",
      "defaultValue": {
        "value": "{}",
        "computed": false
      }
    },
    "width": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Custom viewbox width",
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      }
    },
    "height": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Custom viewbox height",
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      }
    }
  },
  "code": "import React from 'react'\r\nimport PropTypes from 'prop-types'\r\nimport * as icons from './AvailableIcons';\r\n\r\n\r\nfunction Icon({ name, paths, viewBox, width, height, ariaHidden = true, className, color }) {\r\n  const iconPaths = name ? icons[name] : paths\r\n\r\n  return (\r\n    <svg xmlns=\"http://www.w3.org/2000/svg\" \r\n      width={`${width}`}\r\n      height={`${height}`}\r\n      className={className}\r\n      viewBox={`0 0 ${viewBox} ${viewBox}`}\r\n      aria-hidden={ariaHidden}>\r\n      <g fill={color}>\r\n        {iconPaths && iconPaths.map((pathProps, i) => <path {...pathProps} key={i} />)}\r\n      </g>\r\n    </svg>\r\n  );\r\n}\r\n\r\nIcon.propTypes = {\r\n  /**\r\n   * The name of the icon e.g. chevron, facebook etc.\r\n   */\r\n  name: PropTypes.string,\r\n\r\n  /**\r\n   * The color of the icon\r\n   */\r\n  color: PropTypes.string,\r\n\r\n  /**\r\n   * The size of the icon in ems\r\n   */\r\n  size: PropTypes.number,\r\n\r\n  /**\r\n   * The paths of a custom icon\r\n   */\r\n  paths: PropTypes.array,\r\n\r\n  /**\r\n   * Rotate the icon a certain number of degrees\r\n   */\r\n  rotate: PropTypes.number,\r\n\r\n  /**\r\n   * Make the icon spin\r\n   */\r\n  spin: PropTypes.bool,\r\n\r\n  /**\r\n   * Custom viewbox sizing\r\n   */\r\n  viewBox: PropTypes.number,\r\n\r\n  /**\r\n   * Override the default to hide icon from screen readers\r\n   */\r\n  ariaHidden: PropTypes.string,\r\n\r\n  /**\r\n   * Add custom styles to the icon\r\n   */\r\n  styles: PropTypes.object,\r\n\r\n  /**\r\n   *  Custom viewbox width\r\n   */\r\n  width: PropTypes.oneOfType([\r\n    PropTypes.number,\r\n    PropTypes.string\r\n  ]),\r\n\r\n  /**\r\n   *  Custom viewbox height\r\n   */\r\n  height: PropTypes.oneOfType([\r\n    PropTypes.number,\r\n    PropTypes.string\r\n  ])\r\n}\r\n\r\nIcon.defaultProps = {\r\n  color: 'currentColor',\r\n  paths: [],\r\n  rotate: 0,\r\n  size: 1,\r\n  spin: false,\r\n  styles: {},\r\n  viewBox: 24,\r\n  width: '100%',\r\n  height: '100%'\r\n}\r\n\r\nexport default Icon",
  "examples": [{
    "name": "ExampleAllIcons",
    "description": "All Icons",
    "code": "import React from 'react';\r\nimport Icon from 'spunky-ui-react/Icon';\r\nimport Label from 'spunky-ui-react/Label';\r\nimport * as Icons from 'spunky-ui-react/Icon/AvailableIcons';\r\n\r\n/** All Icons */\r\nexport default function ExampleAllIcons() {\r\n\r\n    let icons = Object.keys(Icons).map((icon) => {\r\n        return (\r\n            <div key={icon} style={{\r\n                margin: '25px', \r\n                display: 'inline-block'\r\n            }}>\r\n                <div style={{\r\n                    padding: '12px',  \r\n                    borderRadius: '3px', \r\n                    justifyContent: 'center'\r\n                }} title={icon}>\r\n                    <Icon\r\n                        name={icon} \r\n                        viewBox={24} \r\n                        width={55} \r\n                        height={55} \r\n                        color={'rgb(0,0,0,0.85'} />\r\n                </div>\r\n                <span style={{\r\n                    textAlign: 'center', \r\n                    width: 50, \r\n                    maxWidth: 50, \r\n                    fontSize: '12px', \r\n                    color: 'rgba(0,0,0,.6)'\r\n                }} title={icon}>\r\n                    <Label htmlFor='' label={icon} />\r\n                </span>\r\n            </div>\r\n        );\r\n    });\r\n    \r\n    return <div>{icons}</div>;\r\n}\r\n"
  }]
}, {
  "name": "Input",
  "description": "Password input with integrated label, quality tips, and show password toggle.",
  "props": {
    "htmlId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing."
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input name. Recommend setting this to match object's property so a single change handler can be used by convention."
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Password value"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Input label",
      "defaultValue": {
        "value": "'Password'",
        "computed": false
      }
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function called when password input value changes"
    },
    "maxLength": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Max password length accepted",
      "defaultValue": {
        "value": "50",
        "computed": false
      }
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder displayed when no password is entered"
    },
    "showVisibilityToggle": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set to true to show the toggle for displaying the currently entered password",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "quality": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Display password quality visually via ProgressBar, accepts a number between 0 and 100"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Validation error to display"
    }
  },
  "code": "import React from 'react';\r\nimport PropTypes from 'prop-types';\r\nimport ProgressBar from '../ProgressBar';\r\nimport Icon from '../Icon';\r\nimport Label from '../Label';\r\nimport { renderToStaticMarkup } from 'react-dom/server';\r\n\r\n/** Password input with integrated label, quality tips, and show password toggle. */\r\nclass Input extends React.Component {\r\n  constructor(props) {\r\n    super(props);\r\n    \r\n    this.state = {\r\n      showPassword: false\r\n    };\r\n\r\n    this.toggleShowPassword = this.toggleShowPassword.bind(this);\r\n  }\r\n\r\n  // ES7 class properties\r\n  toggleShowPassword = ev => {\r\n\r\n    this.setState(prevState => {\r\n      return { showPassword: !prevState.showPassword };\r\n    });\r\n\r\n    if (ev) ev.preventDefault();\r\n  }\r\n\r\n  render() {\r\n    const { htmlId, value, label, error, onChange, placeholder, maxLength, showVisibilityToggle, quality, ...props } = this.props;\r\n    const { showPassword } = this.state;\r\n    const svgString = encodeURIComponent(renderToStaticMarkup(<Icon name={showPassword ? 'visibility' : 'visibility_off'} viewBox={24} width={16} height={16} />));\r\n    const dataUri = `url(\"data:image/svg+xml,${svgString}\") center / contain no-repeat`;\r\n    let normalStyle = {\r\n        padding: '10px 35px 10px 10px', \r\n        width: '235px'\r\n    };\r\n    let errorStyle = {\r\n        padding: '10px 35px 10px 10px', \r\n        width: '235px',\r\n        border: 'solid 1px red'\r\n    };\r\n\r\n    let styles = error ? errorStyle : normalStyle;\r\n\r\n    return (\r\n      <div>\r\n        <Label htmlFor={htmlId} label={label} required={true} />\r\n        <div style={{position: 'relative', maxWidth: '235px', cursor: 'pointer' }}>\r\n          <span style={{\r\n            content: \"\",\r\n            position: 'absolute',\r\n            left: '255px',\r\n            top: 0,\r\n            bottom: 0,\r\n            width: '16px',\r\n            height: '40px',\r\n            background: dataUri\r\n          }} onClick={this.toggleShowPassword} />\r\n          \r\n          <label style={{maxWidth: '250px'}}>\r\n            <input \r\n              id={htmlId} \r\n              type={showPassword ? 'text' : 'password'}\r\n              placeholder={placeholder}\r\n              value={value} \r\n              onChange={onChange} \r\n              style={styles}\r\n              {...props} />\r\n\r\n              {error && <div className='error' style={{color: 'red', fontSize: '.75em', fontWeight: 'bold'}}>{error}</div>}\r\n          </label>\r\n        </div>\r\n\r\n        { value.length > 0 && quality && <ProgressBar percent={quality} width={130} height={5} /> }\r\n\r\n      </div>\r\n    );\r\n  }\r\n}\r\n\r\nInput.propTypes = {\r\n  /** Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing. */\r\n  htmlId: PropTypes.string.isRequired,\r\n\r\n  /** Input name. Recommend setting this to match object's property so a single change handler can be used by convention.*/\r\n  name: PropTypes.string.isRequired,\r\n\r\n  /** Password value */\r\n  value: PropTypes.any,\r\n\r\n  /** Input label */\r\n  label: PropTypes.string,\r\n\r\n  /** Function called when password input value changes */\r\n  onChange: PropTypes.func.isRequired,\r\n\r\n  /** Max password length accepted */\r\n  maxLength: PropTypes.number,\r\n\r\n  /** Placeholder displayed when no password is entered */\r\n  placeholder: PropTypes.string,\r\n\r\n  /** Set to true to show the toggle for displaying the currently entered password */\r\n  showVisibilityToggle: PropTypes.bool,\r\n\r\n  /** Display password quality visually via ProgressBar, accepts a number between 0 and 100 */\r\n  quality: PropTypes.number,\r\n\r\n  /** Validation error to display */\r\n  error: PropTypes.string\r\n};\r\n\r\nInput.defaultProps = {\r\n  maxLength: 50,\r\n  showVisibilityToggle: false,\r\n  label: 'Password'\r\n};\r\n\r\nexport default Input;\r\n",
  "examples": [{
    "name": "ExampleInputPassword",
    "description": "Standard Use",
    "code": "import React from 'react';\r\nimport Input from 'spunky-ui-react/Input';\r\n\r\n/** Standard Use */\r\nclass ExampleInputPassword extends React.Component {\r\n    constructor(props) {\r\n        super(props);\r\n\r\n        this.state = {\r\n            password: ''\r\n        };\r\n    }\r\n\r\n    getQuality() {\r\n        const length = this.state.password.length;\r\n        return length > 10 ? 100 : length * 10;\r\n      }\r\n\r\n      // ES7 Class Properties\r\n      setPassword = ev => {\r\n          this.setState({\r\n             password: ev.target.value \r\n          });\r\n      }\r\n    \r\n      render() {\r\n        return (\r\n          <div>\r\n            <Input\r\n              htmlId=\"password-input-example-all-features\"\r\n              name=\"password\"\r\n              onChange={this.setPassword}\r\n              value={this.state.password}\r\n              minLength={8}\r\n              placeholder=\"Enter password\"\r\n              showVisibilityToggle\r\n              quality={this.getQuality()}\r\n              {...this.props} />\r\n          </div>\r\n        )\r\n      }\r\n}\r\n\r\nexport default ExampleInputPassword;"
  }]
}, {
  "name": "Label",
  "description": "Label with required field display, htmlFor, and block styling",
  "props": {
    "htmlFor": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "HTML ID for associated input"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Label text"
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display asterisk after label if true"
    }
  },
  "code": "import React from 'react';\r\nimport PropTypes from 'prop-types';\r\n\r\n/** Label with required field display, htmlFor, and block styling */\r\nfunction Label({htmlFor, label, required}) {\r\n  return (\r\n    <label style={{display: 'block'}} htmlFor={htmlFor}>\r\n      {label} { required && <span style={{color: 'red'}}> *</span> }\r\n    </label>\r\n  )\r\n}\r\n\r\nLabel.propTypes = {\r\n  /** HTML ID for associated input */\r\n  htmlFor: PropTypes.string.isRequired,\r\n\r\n  /** Label text */\r\n  label: PropTypes.string.isRequired,\r\n\r\n  /** Display asterisk after label if true */\r\n  required: PropTypes.bool\r\n};\r\n\r\nexport default Label;\r\n",
  "examples": [{
    "name": "ExampleOptional",
    "description": "Standard Use",
    "code": "import React from 'react';\r\nimport Label from 'spunky-ui-react/Label';\r\n\r\n/** Standard Use */\r\nexport default function ExampleOptional() {\r\n    return <Label htmlFor='test' label='Normal Label' />;\r\n}"
  }, {
    "name": "ExampleRequired",
    "description": "Required Input",
    "code": "import React from 'react';\r\nimport Label from 'spunky-ui-react/Label';\r\n\r\n/** Required Input */\r\nexport default function ExampleRequired() {\r\n    return <Label htmlFor='test' label='Required Label' required={true} />;\r\n}"
  }]
}, {
  "name": "PasswordInput",
  "description": "Password input with integrated label, quality tips, and show password toggle.",
  "props": {
    "htmlId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing."
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input name. Recommend setting this to match object's property so a single change handler can be used by convention."
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Password value"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Input label",
      "defaultValue": {
        "value": "'Password'",
        "computed": false
      }
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function called when password input value changes"
    },
    "maxLength": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Max password length accepted",
      "defaultValue": {
        "value": "50",
        "computed": false
      }
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder displayed when no password is entered"
    },
    "showVisibilityToggle": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set to true to show the toggle for displaying the currently entered password",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "quality": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Display password quality visually via ProgressBar, accepts a number between 0 and 100"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Validation error to display"
    }
  },
  "code": "import React from 'react';\r\nimport PropTypes from 'prop-types';\r\nimport ProgressBar from '../ProgressBar';\r\nimport Icon from '../Icon'\r\nimport TextInput from '../TextInput';\r\n\r\n/** Password input with integrated label, quality tips, and show password toggle. */\r\nclass PasswordInput extends React.Component {\r\n  constructor(props) {\r\n    super(props);\r\n    \r\n    this.state = {\r\n      showPassword: false\r\n    };\r\n\r\n    this.toggleShowPassword = this.toggleShowPassword.bind(this);\r\n  }\r\n\r\n  // ES7 class properties\r\n  toggleShowPassword = ev => {\r\n\r\n    this.setState(prevState => {\r\n      return { showPassword: !prevState.showPassword };\r\n    });\r\n\r\n    if (ev) ev.preventDefault();\r\n  }\r\n\r\n  render() {\r\n    const { htmlId, value, label, error, onChange, placeholder, maxLength, showVisibilityToggle, quality, ...props } = this.props;\r\n    const { showPassword } = this.state;\r\n\r\n    return (\r\n      <TextInput\r\n        htmlId={htmlId}\r\n        label={label}\r\n        placeholder={placeholder}\r\n        type={showPassword ? 'text' : 'password'}\r\n        onChange={onChange}\r\n        value={value}\r\n        maxLength={maxLength}\r\n        error={error}\r\n        required\r\n        {...props}>\r\n\r\n        {showVisibilityToggle &&\r\n          <a\r\n            href=\"./\"\r\n            onClick={this.toggleShowPassword}\r\n            style={{ marginLeft: 5 }}>\r\n            <Icon name={showPassword ? 'visibility' : 'visibility_off'} width={16} color={'rgb(0,0,0, 0.87'} />\r\n          </a>\r\n        }\r\n\r\n        { value.length > 0 && quality && <ProgressBar percent={quality} width={130} /> }\r\n\r\n      </TextInput>\r\n    );\r\n  }\r\n}\r\n\r\nPasswordInput.propTypes = {\r\n  /** Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing. */\r\n  htmlId: PropTypes.string.isRequired,\r\n\r\n  /** Input name. Recommend setting this to match object's property so a single change handler can be used by convention.*/\r\n  name: PropTypes.string.isRequired,\r\n\r\n  /** Password value */\r\n  value: PropTypes.any,\r\n\r\n  /** Input label */\r\n  label: PropTypes.string,\r\n\r\n  /** Function called when password input value changes */\r\n  onChange: PropTypes.func.isRequired,\r\n\r\n  /** Max password length accepted */\r\n  maxLength: PropTypes.number,\r\n\r\n  /** Placeholder displayed when no password is entered */\r\n  placeholder: PropTypes.string,\r\n\r\n  /** Set to true to show the toggle for displaying the currently entered password */\r\n  showVisibilityToggle: PropTypes.bool,\r\n\r\n  /** Display password quality visually via ProgressBar, accepts a number between 0 and 100 */\r\n  quality: PropTypes.number,\r\n\r\n  /** Validation error to display */\r\n  error: PropTypes.string\r\n};\r\n\r\nPasswordInput.defaultProps = {\r\n  maxLength: 50,\r\n  showVisibilityToggle: false,\r\n  label: 'Password'\r\n};\r\n\r\nexport default PasswordInput;\r\n",
  "examples": [{
    "name": "ExampleAllFeatures",
    "description": "Standard Use",
    "code": "import React from 'react';\r\nimport PasswordInput from 'spunky-ui-react/PasswordInput';\r\n\r\n/** Standard Use */\r\nclass ExampleAllFeatures extends React.Component {\r\n    constructor(props) {\r\n        super(props);\r\n\r\n        this.state = {\r\n            password: ''\r\n        };\r\n    }\r\n\r\n    getQuality() {\r\n        const length = this.state.password.length;\r\n        return length > 10 ? 100 : length * 10;\r\n      }\r\n\r\n      // ES7 Class Properties\r\n      setPassword = ev => {\r\n          this.setState({\r\n             password: ev.target.value \r\n          });\r\n      }\r\n    \r\n      render() {\r\n        return (\r\n          <div>\r\n            <PasswordInput\r\n              htmlId=\"password-input-example-all-features\"\r\n              name=\"password\"\r\n              onChange={this.setPassword}\r\n              value={this.state.password}\r\n              minLength={8}\r\n              placeholder=\"Enter password\"\r\n              showVisibilityToggle\r\n              quality={this.getQuality()}\r\n              {...this.props} />\r\n          </div>\r\n        )\r\n      }\r\n}\r\n\r\nexport default ExampleAllFeatures;"
  }]
}, {
  "name": "ProgressBar",
  "description": "Progress bar with color coded status of progress",
  "props": {
    "percent": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": "Percent of progress completed"
    },
    "width": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Bar width",
      "defaultValue": {
        "value": "250",
        "computed": false
      }
    },
    "height": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Bar height",
      "defaultValue": {
        "value": "5",
        "computed": false
      }
    },
    "showPercentage": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Show percentage text",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    }
  },
  "code": "import React from 'react';\r\nimport PropTypes from 'prop-types';\r\nimport * as PercentUtils from '../utils/percentUtils';\r\n\r\n/** Progress bar with color coded status of progress */\r\nclass ProgressBar extends React.Component {\r\n\r\n  render() {\r\n    const {percent, width, showPercentage} = this.props;\r\n    const percentWidth = PercentUtils.getWidthAsPercentOfTotalWidth(percent, width);\r\n\r\n    return (\r\n      <div className=\"progressbar\" style={{width: width}}>\r\n        <div style={{width: percentWidth, backgroundColor: '#00695C'}}>\r\n          {showPercentage && <div>{`${percent.toFixed(0)}%`}</div>}\r\n        </div>\r\n      </div>\r\n    );\r\n  }\r\n}\r\n\r\nProgressBar.propTypes = {\r\n  /** Percent of progress completed */\r\n  percent: PropTypes.number.isRequired,\r\n\r\n  /** Bar width */\r\n  width: PropTypes.number.isRequired,\r\n\r\n  /** Bar height */\r\n  height: PropTypes.number,\r\n\r\n  /** Show percentage text */\r\n  showPercentage: PropTypes.bool\r\n};\r\n\r\nProgressBar.defaultProps = {\r\n  height: 5,\r\n  width: 250,\r\n  showPercentage: false\r\n};\r\n\r\nexport default ProgressBar;",
  "examples": [{
    "name": "Example100Percent",
    "description": "Linear Progress Bar",
    "code": "import React from 'react';\r\nimport ProgressBar from 'spunky-ui-react/ProgressBar';\r\nimport Label from 'spunky-ui-react/Label';\r\n\r\n/** Linear Progress Bar */\r\nexport default class Example100Percent extends React.Component {\r\n    state = {\r\n        completed: 0\r\n    };\r\n\r\n    componentDidMount() {\r\n        this.timer = setInterval(this.progress, 500);\r\n    }\r\n\r\n    componentWillUnmount() {\r\n        clearInterval(this.timer);\r\n    }\r\n\r\n    progress = () => {\r\n        const { completed } = this.state;\r\n\r\n        if (completed === 100) {\r\n            this.setState({ completed: 0});\r\n        } else {\r\n            const diff = Math.random() * 10;\r\n            this.setState({completed: Math.min(completed + diff, 100) });\r\n        }\r\n    }\r\n\r\n    render() {\r\n        return (\r\n            <div>\r\n                <h5><Label htmlFor={''} label={'Showing Percentage'} /></h5>\r\n                <ProgressBar \r\n                    percent={this.state.completed} \r\n                    width={450} \r\n                    showPercentage={true} />\r\n                <br />\r\n                <h5><Label htmlFor={''} label={'Not Showing Percentage'} /></h5>\r\n                <ProgressBar \r\n                    percent={this.state.completed} \r\n                    width={450} />\r\n                    \r\n            </div>\r\n        );\r\n    }\r\n\r\n}\r\n"
  }, {
    "name": "Example20Percent",
    "description": "20% progress",
    "code": "import React from 'react';\r\nimport ProgressBar from 'spunky-ui-react/ProgressBar';\r\n\r\n/** 20% progress */\r\nexport default function Example20Percent() {\r\n    return <ProgressBar percent={20} width={150} showPercentage={true} />;\r\n}"
  }, {
    "name": "Example70Percent",
    "description": "70% progress",
    "code": "import React from 'react';\r\nimport ProgressBar from 'spunky-ui-react/ProgressBar';\r\n\r\n/** 70% progress */\r\nexport default function Example70Percent() {\r\n    return <ProgressBar percent={70} showPercentage={true} />;\r\n}"
  }]
}, {
  "name": "RegistrationForm",
  "description": "Registration form with built-in validation.",
  "props": {
    "passwordQuality": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": "The quality of the password"
    },
    "onSubmit": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Called when form is submitted"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Called when text for email or password changes"
    },
    "user": {
      "type": {
        "name": "object"
      },
      "required": true,
      "description": "User object containg email and password"
    }
  },
  "code": "import React from 'react';\r\nimport PropTypes from 'prop-types';\r\n// import TextInput from '../TextInput';\r\n// import PasswordInput from '../PasswordInput';\r\nimport Input from '../Input';\r\n\r\n/** Registration form with built-in validation. */\r\n  function RegistrationForm({user, passwordQuality, onChange, onSubmit, errors}) {\r\n    return (\r\n      <div>\r\n        <Input\r\n          htmlId=\"registration-form-email\"\r\n          name=\"email\"\r\n          onChange={onChange}\r\n          label=\"Email\"\r\n          value={user.email}\r\n          error={errors.email}\r\n          required />\r\n\r\n        <Input\r\n          htmlId=\"registration-form-password\"\r\n          name=\"password\"\r\n          value={user.password}\r\n          onChange={onChange}\r\n          quality={passwordQuality}\r\n          showVisibilityToggle\r\n          maxLength={50}\r\n          error={errors.password} />\r\n\r\n        <input type=\"submit\" value=\"Register\" onClick={onSubmit} />\r\n      </div>\r\n    );\r\n  }\r\n\r\nRegistrationForm.propTypes = {\r\n  /** The quality of the password */\r\n  passwordQuality: PropTypes.number.isRequired,\r\n\r\n  /** Called when form is submitted */\r\n  onSubmit: PropTypes.func.isRequired,\r\n\r\n  /** Called when text for email or password changes */\r\n  onChange: PropTypes.func.isRequired,\r\n\r\n  /** User object containg email and password */\r\n  user: PropTypes.object.isRequired\r\n}\r\n\r\n\r\nexport default RegistrationForm;\r\n",
  "examples": [{
    "name": "ExampleRegistrationForm",
    "description": "Registration Form",
    "code": "import React from 'react';\r\nimport RegistrationForm from 'spunky-ui-react/RegistrationForm';\r\n\r\n/**  Registration Form*/\r\nexport default class ExampleRegistrationForm extends React.Component {\r\n      onSubmit = user => {\r\n        const message = `Thank you ${user.email} \\\r\n          for registering, your password '${user.password}' \\\r\n          is safe with us! ;-)`;\r\n        alert(message);\r\n      };\r\n    \r\n      render() {\r\n        return <RegistrationForm onSubmit={this.onSubmit} />;\r\n      }\r\n\r\n}\r\n"
  }]
}, {
  "name": "TextInput",
  "description": "Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker.",
  "props": {
    "htmlId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique HTML ID. Used for tying label to HTML input. Good hook for automated testing."
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input name. Recommend setting this to match object's property so a single change handler can be used."
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input label"
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'text'",
          "computed": false
        }, {
          "value": "'number'",
          "computed": false
        }, {
          "value": "'password'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Input type",
      "defaultValue": {
        "value": "'text'",
        "computed": false
      }
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Mark label with asterisk if set to true",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function to call onChange"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder to display when empty"
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Value"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String to display when error occurs"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Child component to display next to the input"
    }
  },
  "code": "import React from 'react';\r\nimport PropTypes from 'prop-types';\r\nimport Label from '../Label';\r\n\r\n/** Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker. */\r\nfunction TextInput({htmlId, name, label, type = 'text', required = false, onChange, placeholder, value, error, children, ...props}) {\r\n    return (\r\n        <div style={{marginBottom: 16}}>\r\n            <Label htmlFor={htmlId} label={label} required={required} />\r\n\r\n            <input \r\n                id={htmlId} \r\n                type={type} \r\n                name={name} \r\n                placeholder={placeholder}\r\n                value={value} \r\n                onChange={onChange} \r\n                style={error && {border: 'solid 1px red'}}\r\n                {...props} />\r\n\r\n            {children}\r\n\r\n            {error && <div style={{color: 'red', fontSize: '.75em', fontWeight: 'bold'}}>{error}</div>}\r\n        </div>\r\n    );\r\n};\r\n\r\nTextInput.propTypes = {\r\n  /** Unique HTML ID. Used for tying label to HTML input. Good hook for automated testing. */\r\n  htmlId: PropTypes.string.isRequired,\r\n\r\n  /** Input name. Recommend setting this to match object's property so a single change handler can be used. */\r\n  name: PropTypes.string.isRequired,\r\n\r\n  /** Input label */\r\n  label: PropTypes.string.isRequired,\r\n\r\n  /** Input type */\r\n  type: PropTypes.oneOf(['text', 'number', 'password']),\r\n\r\n  /** Mark label with asterisk if set to true */\r\n  required: PropTypes.bool,\r\n\r\n  /** Function to call onChange */\r\n  onChange: PropTypes.func.isRequired,\r\n\r\n  /** Placeholder to display when empty */\r\n  placeholder: PropTypes.string,\r\n\r\n  /** Value */\r\n  value: PropTypes.any,\r\n\r\n  /** String to display when error occurs */\r\n  error: PropTypes.string,\r\n\r\n  /** Child component to display next to the input */\r\n  children: PropTypes.node\r\n};\r\n\r\nexport default TextInput;",
  "examples": [{
    "name": "ExampleError",
    "description": "Required TextInput showing an error",
    "code": "import React from 'react';\r\nimport TextInput from 'spunky-ui-react/TextInput';\r\n\r\n/** Required TextInput showing an error */\r\nexport default class ExampleError extends React.Component {\r\n    render() {\r\n        return <TextInput \r\n                htmlId='example-required'\r\n                label='First Name'\r\n                name='firstname'\r\n                onChange={() => {}}\r\n                required\r\n                error='First name is required.'\r\n            />;\r\n    }\r\n};\r\n"
  }, {
    "name": "ExampleOptional",
    "description": "Optional TextInput",
    "code": "import React from 'react';\r\nimport TextInput from 'spunky-ui-react/TextInput';\r\n\r\n/** Optional TextInput */\r\nexport default class ExampleOptional extends React.Component {\r\n    render() {\r\n        return <TextInput \r\n                htmlId='example-optional'\r\n                label='First Name'\r\n                name='firstname'\r\n                onChange={() => {}}\r\n            />;\r\n    }\r\n};\r\n"
  }, {
    "name": "ExamplePlaceholder",
    "description": "TextInput with placeholder",
    "code": "import React from 'react';\r\nimport TextInput from 'spunky-ui-react/TextInput';\r\n\r\n/** TextInput with placeholder */\r\nexport default class ExamplePlaceholder extends React.Component {\r\n    render() {\r\n        return <TextInput \r\n                htmlId='example-placeholder'\r\n                label='First Name'\r\n                name='firstname'\r\n                placeholder='Type first name here'\r\n                onChange={() => {}}\r\n            />;\r\n    }\r\n};\r\n"
  }]
}];